import MobileNavItem from './MobileNavItem.component';
export default MobileNavItem;